/**
 * features/compliance/useCompliance.ts
 * Live subscription to compliance items.
 */
import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { COLLECTIONS, type ComplianceItem } from '@/types';

export function useCompliance() {
  const [items, setItems] = useState<ComplianceItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, COLLECTIONS.complianceItems), orderBy('createdAt', 'desc'));
    return onSnapshot(
      q,
      (snap) => {
        setItems(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<ComplianceItem, 'id'>) })));
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  return { items, loading };
}
